import { Avatar } from '@commenda/kakashi';
import { IUserCalendar } from '@commenda/types/src/user';
import Image from 'next/image';
import React from 'react';
import ReactCountryFlag from 'react-country-flag';

const CalendarSideNav = ({
  data,
  children,
}: {
  data: IUserCalendar;
  children: React.ReactNode;
}) => {
  return (
    <div className="hidden md:flex bg-white padding-4 min-w-[100%] min-h-[100vh] flex-col items-center">
      <div className="w-[100%] flex flex-col items-center bg-[#F3F4F6] min-h-[calc(100vh-64px)] gap-[30px] rounded-bl-3xl rounded-br-3xl">
        <div className="flex items-center flex-col gap-1 bg-[#F3F4F6] mt-[8%]">
          <Avatar
            size="2xl"
            className="size-[84px]"
            name={data?.name}
            image={
              data?.avatar ? `data:image/png;base64,${data.avatar}` : undefined
            }
            colorSeed={data?.id}
          />

          <div className="flex flex-col gap-1 items-center">
            <h1>{data?.name}</h1>
          </div>
        </div>
        <div className="border-t border-stroke-2 h-fit w-full pt-6 gap-4 flex flex-col max-w-[650px]">
          <div className="flex justify-between w-full">
            <span className="body-15-medium text-neutral-3 self-start">
              Firm
            </span>
            <span className="body-15-regular text-neutral-3 self-end w-[70%]">
              {data?.caFirm?.name}
            </span>
          </div>
          <div className="flex justify-between w-full">
            <span className="body-15-medium text-neutral-3 self-start">
              About
            </span>
            <span className="body-15-regular text-neutral-3 self-end w-[70%]">
              {data?.caFirm?.description}
            </span>
          </div>
          <div className="flex justify-between w-full">
            <span className="body-15-medium text-neutral-3 self-start">
              Markets
            </span>
            <div className="flex gap-2 self-end w-[70%]">
              {data?.caFirm?.supportedMarkets?.map((country) => (
                <ReactCountryFlag
                  className="emojiFlag"
                  countryCode={country}
                  style={{
                    fontSize: '24px',
                    backgroundColor: '#CF060D1A',
                    padding: '4px 3px',
                    borderRadius: '4px',
                    height: '30px',
                    width: '30px',
                  }}
                  aria-lable={country}
                  key={country}
                />
              ))}
            </div>
          </div>
        </div>
        <div className="">{children}</div>
      </div>
      <div className="flex items-center gap-2 pt-5">
        <span className="body-12-medium text-neutral-2">Powered by</span>
        <div className="flex items-center gap-[2px]">
          <Image
            src="/commenda-new-logo.svg"
            alt="Commenda Logo"
            height={20}
            width={20}
          />
          <h3 className="text-neutral-2">Commenda</h3>
        </div>
      </div>
    </div>
  );
};

export default CalendarSideNav;
